<template>
    <div>
        <v-layout row wrap xs12>
            <!-- debut dialog -->
            <v-dialog v-model="openDialog" max-width="70%">
                <v-card>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout row wrap xs12>
                                <span class="cyan--text text--darken-3 font-weight-bold">ATTENTION :&nbsp;</span> Vous souhaitez postuler à l'ECE pour le programme &nbsp;
                                <span class="cyan--text text--darken-3 font-weight-bold">{{$storeCandidature.redirectionConcours.ProgrammeLabel}}</span>
                            </v-layout>
                            <v-layout row wrap xs12 class="mt-3">
                                <span class="font-weight-black">{{$storeCandidature.langueFormulaire == 'en' ? 'For this you must submit your application on' : 'Pour cela vous devez déposer votre candidature sur :'}}</span>&nbsp;
                                <a class="cyan--text text--darken-3 font-weight-bold" v-bind:href="$storeCandidature.redirectionConcours.RedirectUrl">{{$storeCandidature.redirectionConcours.RedirectUrl}}</a>
                            </v-layout>
                            <v-layout justify-center>
                                <v-img v-if="$storeCandidature.redirectionConcours.LogoUrl"
                                       :src="$storeCandidature.redirectionConcours.LogoUrl"
                                       style="max-height:20%; max-width:20%" class="my-5">
                                </v-img>
                            </v-layout>
                            <v-layout row wrap xs12>
                                Notre équipe reste à votre entière disposition pour répondre à vos questions
                            </v-layout>
                            <div id="contact" class="ml-2">
                                <v-layout row wrap xs12>
                                    A très bientôt
                                </v-layout>
                                <v-layout row wrap xs12>
                                    <span class="cyan--text text--darken-3 font-weight-bold">Campus Lyon :&nbsp;</span>+33 4 78 29 77 54
                                </v-layout>
                                <v-layout row wrap xs12>
                                    <span class="cyan--text text--darken-3 font-weight-bold">Campus Paris :&nbsp;</span>+33 1 44 39 21 15
                                </v-layout>
                                <v-layout row wrap xs12>
                                    <span class="cyan--text text--darken-3 font-weight-bold">Email :&nbsp;</span>admissions@ece.fr
                                </v-layout>
                            </div>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature
            }
        },

        computed: {
            openDialog() {
                return this.$storeCandidature.redirectionConcours && this.$storeCandidature.redirectionConcours.AfficherDialog
            }
        },

        methods: {},
    }
</script>

